export function getKiyaku(building_id: string) {
  let building_title = 'インターネットを用いたオンライン対話学習事業 ろう・難聴児のオンライン対話学習コミュニティ「Circle O」';
  let name_full = '「Circle O（サークルオー）」（以下「サークルオー」といいます）';
  let name = 'サークルオー';
  if (building_id === 'da01') {
    building_title = 'ろう・難聴児専門の児童発達支援・放課後等デイサービス「デフアカデミー」';
    name = 'デフアカデミー';
    name_full = '「デフアカデミー」';
  }
  const kiyaku = `
${building_title} 利用契約約款

第１条（目的）
本約款は，NPO法人 Silent Voice（以下「当法人」といいます）が，利用契約者との間で，インターネットを用いたオンライン対話学習事業${name_full}の利用に関する契約内容を定めるものです。

第２条（定義）
本約款で定める用語は以下のとおりとします。
①本契約：本約款に基づき，利用契約者と当法人との間で成立した利用契約をいいます。
②生徒：利用契約によって，本サービスの利用者として登録された方をいいます。
③利用契約者：当法人と ${name}利用契約約款に基づく契約を締結した者をいいます。但し，生徒が成年の場合は生徒が利用契約者となり，生徒が未成年の場合は，その保護者が利用契約者となります。
④先生：当法人との契約により，先生として登録され，生徒の指導にあたる者をいいます。
⑤本サービス：当法人が利用契約者又は生徒に提供するオンライン対話学習のサービスをいいます。

第３条（約款の適用）
１ 本約款は，本サービスを利用する全ての利用契約者及び生徒に適用されます。
２ 本約款は，当法人の判断により変更することがあります。この場合，当法人の定める施行日から変更後の約款が適用されます。
３ 当法人と，利用契約者又は生徒が，本約款と異なる事項を文書により合意した場合は，当該合意が本約款に優先します。
４ 利用契約者は，自己の登録した生徒に，本約款に定める義務を遵守させるものとし，
生徒の債務不履行，不法行為又は約款違反に関する責任について，生徒と連帯して責任
を負うものとします。

第４条（契約の成立）
１ 利用契約者及び生徒は，当法人の定める方式に従って，登録情報を登録して，契約の
申込みをします。
２ 当法人は，登録済みの契約者に対して，契約承諾の可否を決めます。
３ 利用契約者の，契約申込みに対して，当法人が承諾した時点で，本契約が成立するもの
とします。
４ 以下の場合は，当法人は，契約の承諾を撤回できます。
 ① 利用契約者又は生徒が，申込時に虚偽の事項を申告した場合
 ② 利用契約者又は生徒が，約款に契約違反をした場合
 ③ 利用契約者が，過去に利用契約者又は生徒の約款違反を理由とする解除が存在するとき
 ④ 利用契約者の与信条件を満たさない場合
 ⑤ その他相当の事由がある場合
５ 利用契約者は，本契約についての申込みの撤回・解除は一切出来ません。

第５条（個人情報等の利用）
１ 利用契約者及び生徒は，当法人に提供した個人情報を，当法人，当法人の指定する先生が，以下の目的で利用することをあらかじめ承諾します。
 ① 本サービスの提供
 ② 先生による授業提供
 ③ 本サービスに関するご案内
 ④ 本サービス，その他当法人のサービスに関するダイレクトメールの送付
 ⑤ 顧客満足度調査
 ⑥ 市場調査
 ⑦ その他上記に関連する事項
２ 当法人は，利用契約者及び生徒の個人情報その他秘密情報を，契約期間中はもとより
契約終了後においても，第三者に漏洩しないものとします。

第６条（サービスの内容）
本サービスの概要は以下のとおりとします。
 ① オンライン授業
 ② テキストの提供
 ③ 定期面談
 ④ 模擬テスト
 ⑤ その他上記に関連するサービス

第７条（授業の実施）
１ 利用契約者は，予約済みの授業，本サービス利用額の範囲内で，生徒が自己の判断で受講することをあらかじめ承諾します。
２ 当法人，利用契約者及び生徒は，本約款，その他の約款に従い，関係諸法規を遵守して授業を実施します。
３ 利用契約者又は生徒は，登録事項に変更があった場合は，遅滞なく当法人へ連絡し，登録変更手続きを行います。
４ 利用契約者又は生徒は，授業終了後，授業フィードバックシートにて，先生の評価を入力します。

第８条（テキスト等の使用許諾）
１当法人は，生徒に対して，授業実施のためにテキスト，テスト等の教材の利用を許諾することが出来ます。
２ 利用契約者及び生徒は，前項の教材を授業又はテストの実施のみに使用し，当社の秘密情報として管理します。

第９条（Zoomの利用）
第９条（オンライン会議用ツールの利用）
１ 利用契約者及び生徒は，当法人が指定するオンライン会議用ツールを，当社の指示に従って利用できます。
２ 各種授業の受講に必要な機器及びソフトウェアは，利用契約者及び生徒がこれを用意し，予めその機能を確認しなければなりません。
３ 各種授業の受講に要するインターネット接続に関する通信費用，その他、本サービスの利用に要する費用は，利用契約者及び生徒の負担とします。また，コンピュータウィルス対策など，正常に本サービス利用するために要する費用も生徒の負担とします。
４ 利用契約者及び生徒は，本サービスを当法人が指定する利用目的でのみ利用し，他の目的に利用してはいけません。
５ 利用契約者及び生徒は，本サービスにかかるネットワーク又はシステムに支障を生じさせるようなソフトウェアの稼働またはその他の妨害行為をしないものとします。
６ 利用契約者及び生徒は，本システムを利用する環境が常に良好なシステム・インターネット環境となるようにします。
７ 各種授業受講時に発生したオンライン会議用ツール以外の機能の不具合により生じた障害について，授業に支障が生じても当法人は一切責任を負わないこととします。

第１０条（料金）
１ 利用契約者は，以下の料金を支払うものとします。
 ①授業料：授業受講毎に授業完了時に料金が発生します。
２ 料金の支払方法は，毎月末を締日とし，口座振替による決済方法とします。
３ 利用契約者又は生徒が料金支払いについて口座振替を選択している場合は，支払い日を翌月２６日とします。なお、振込手数料その他支払いに必要な費用は利用契約者又は生徒の負担とします。
４利用契約者に授業料の発生する場合において、生徒が授業開始予定時刻の1時間前以降にキャンセルした場合は生徒側の「キャンセル」扱いとし、その時点をもって授業料を支払うものとします。また事前連絡がなく授業開始予定時刻の10分を過ぎた場合は生徒側の「無断キャンセル」とする。
５ 当法人は，受領済みの料金は，理由の如何を問わず返金いたしません。
６ 上記第１０条(料金)に関する条項は，通常授業に対するものであり，無償提供に該当する授業はこの対象外とします。

第１１条（損害賠償）
利用契約者又は生徒は，約款等に違反し，当法人に損害が生じた場合には，利用契約者又は生徒は当該損害を賠償する義務を負うものとします。

第１２条（契約期間）
本契約の期間は，契約成立日から契約成立日の属する月の末日までとし，当法人又は利用契約者から契約を更新しない旨の意思表示がない限り，１ヶ月間同一の条件で継続するものとし，その後も同様とします。

第１３条（解除）
当法人は，利用契約者又は生徒が，以下の各号の１つにでも該当した場合，何ら催告無く，契約を解除出来ます。
① 利用契約者又は生徒が，申込時に虚偽の事項を申告した場合
② 利用契約者又は生徒が，契約違反をした場合
③ 利用契約者又は生徒が，無償提供の授業を累計３回無断キャンセルした場合
④ 利用契約者が，与信条件を満たさなくなった場合
⑤ 利用契約者が，料金の支払いを怠った場合
⑥ 利用契約者又は生徒が登録した連絡先に連絡が取れなくなった場合
⑦ 利用契約者又は生徒が，他の先生、利用契約者及び生徒を含む本サービス関係者に対して，あらゆる勧誘行為や営業行為を行った場合。
⑧ その他契約の継続が困難な相当の事由があるとき。

第１４条（利用停止規定）
１ 期日まで銀行振込が確認できなかった場合，利用契約者又は生徒は期日から７日間以内（期日が金融機関営業休日となる場合はその翌営業日）までに当法人指定の金融機関への振込を行うものとします。
２ 前項における振込が無かった場合，利用契約者又は生徒の本サービスの利用を停止します。

第１５条（清算）
１ 終了原因の如何によらず，本契約が終了した場合，当法人並びに利用契約者及び生徒は債権債務を速やかに清算するものとします。

第１６条（サービスの停止）
１ 当法人は，以下の場合，サービスの一部又は全部について，中止，中断又は廃止が出来ます。
 ① 地震，火災，台風，その他の事由により本サービスの提供が困難となった場合。
 ② 利用契約者又は生徒に，契約解除事由が存在する場合。
 ③ 当法人の経営判断により，サービスの廃止，停止又は譲渡を決定した場合。
２ 本サービスの中止・変更等の情報は，遅滞なく利用契約者又は生徒に通知するものとします。
３ 授業中に発生した天災地変やシステム障害等により，授業が中断した場合の授業料に関しては課金しないものとします。

第１７条（免責）
当法人は，以下の各号の場合，一切の責任を負わないものとします。
① 損害が，不可抗力，その他当法人の責に帰すことができない事由により生じた場合
② 損害が，利用契約者又は生徒の責により生じた場合
③ 損害が，本約款に定めるサービス停止事由により生じた場合

第１８条（協議事項）
本約款に定めない事項について疑義を生じた場合には，その都度，利用契約者及び生徒と当法人は，誠意をもって協議を行うものとします。

第１９条（準拠法）
本約款及び本契約に関する事項は，日本国法を準拠法とします。

第２０条（管轄裁判所）
本契約及び本約款上の紛争，その他関連する一切の紛争については，訴額に応じて当法人の所在地を管轄する地方裁判所又は簡易裁判所を第一審の専属的合意管轄裁判所とします。

以上


令和2年7月15日制定
令和3年8月16日改定
令和4年2月11日改定
令和4年12月14日改定

大阪府大阪市中央区安堂寺町1丁目3-12 大阪谷町ビル4F

NPO法人 Silent Voice
代表理事 尾中 友哉

`;
  return `<pre>${kiyaku}</pre>`;
}
